// extracted by mini-css-extract-plugin
module.exports = {"container":"KdaPbzQAM_Y0FIvb-dlfX"};